module.exports = __webpack_public_path__ + "img/zhifubao-normal.8c9c9d3f.png";